module.exports = __webpack_public_path__ + "assets/images/chef_05_bafd582de2296e85b8384acce88a12f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/chef_05.png
// module id = 187
// module chunks = 0